export default "__VITE_ASSET__CozdC77V__"